import useTheme from './use-theme'

export function useFont() {
  const { customFonts, fontFamilies } = useTheme()

  return { body: customFonts[fontFamilies.body] } as const
}
